import axios from 'axios'
import {ResponseObject} from '../../../../../models'
import {ObjectIdModule} from '../../modules/models'
import {FurnitureModel} from '../models'
const BASEURL = process.env.REACT_APP_DEV_API_HOTELERIA_URL

export async function deleteFurnitureService(dto: ObjectIdModule[]) {
  return await axios.delete<ResponseObject<FurnitureModel>>(
    `${BASEURL}/furniture/deleteFurniture`,
    {
      data: dto,
    },
  )
}
